import React from 'react'
import { BaseForm, Input } from '../../../../components/Form'

import { getMessage } from '../../../../lib/translator'

export default class Filters extends BaseForm {
  render() {
    const { SubmitButton, ClearButton } = this.buttons
    const { Form } = this.components
    return (
      <Form>
        <div className="form-fields">
          <Input
            label={getMessage('order.filters.referenceNumber.heading')}
            placeholder={getMessage(
              'order.filters.referenceNumber.placeholder'
            )}
            name="reference"
            type="text"
            {...this.generateStateMappers({
              stateKeys: ['id'],
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        <SubmitButton>{getMessage('order.filters.submitText')}</SubmitButton>
        <ClearButton>
          {getMessage('order.filters.clearFiltersText')}
        </ClearButton>
      </Form>
    )
  }
}
